import React from "react";

const Intro: React.FC = () => {
  return (
    <div className="max-w-2xl mx-auto px-5 py-5 text-center text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Find the right newcomer service</h1>
      <p className="text-base text-gray-500 mb-2">
        This pilot helps you understand which organizations may be able to support you.
        It does not replace any service provider and does not give legal or immigration advice.
      </p>
      <p className="text-sm text-gray-500 italic">
        You may be referred to more than one organization.
      </p>
    </div>
  );
};

export default Intro;
